import { zdarKidsCustomCiphers } from '../zdarKidsGameCustomCiphers';
import audio from '../../../../assets/audio/kids-tracks/Text25.mp3';

export const step34tree = {
    id: 34,
    title: 'Strom',
    taskText: `
        <p>
            Žádný duch? Rovnou úkol, to je vážně divné, snad ho neděláme jen tak. 
        </p>
    `,
    cipher: {
        label: 'Úkol',
        custom: zdarKidsCustomCiphers.pexeso,
    },
    continueButtonText: 'Pokračovat',
    points: true,
    audio: audio,
};
